import React from 'react';
import { connect } from 'react-redux';
import { ACCOUNTS_MENU as RAW_MENU } from 'components/web-feature/account/accounts.routes';
import Icon from '../../mweb/Icon/Icon';
import { Link } from 'react-router-dom';
import { isLoggedInUser } from 'hb-redux-store/util/cookieService';
import { showLoginModal } from 'hb-redux-store/feature/modal/modal.action';
import InviteAndEarn from 'components/mweb/InviteAndEarn/InviteAndEarn';

const AccountMenu = props => {
  const isUserLoggedIn = isLoggedInUser();
  const ACCOUNTS_MENU = RAW_MENU.map(menu => ({
    ...menu,
    subMenu: menu.subMenu.filter(subMenu => {
      if (subMenu.key === 'referral') {
        return props.isReferralActive;
      }
      return true;
    }),
  }));
  const onMenuClick = (subMenu, e) => {
    if (
      !isUserLoggedIn &&
      [
        'addresses',
        'new-address',
        'payments',
        'vxl-point',
        // 'halalbox-wallet',
        'vxl-money',
        'referrals',
      ].includes(subMenu.key) > 0
    ) {
      props.showLoginModal(true);
      return;
    }
    props.selectedMenu(subMenu.key);
    if (subMenu.key !== 'logout') {
      return true;
    }
    if (subMenu.isPrivate && !isUserLoggedIn) return false;
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    props.onLogout();
  };

  const getMenuLinks = menu => {
    if (!menu.isPrivate || (menu.isPrivate && isUserLoggedIn)) return menu.url;
  };

  return ACCOUNTS_MENU.map((menu, index) => (
    <div key={menu.key}>
      {menu.subMenu.map(subMenu => {
        if (subMenu.isExternalLink) {
          return (
            <a
              href={subMenu.url}
              target="_blank"
              className="sub-menu justify-content--space-between "
              key={subMenu.key}
              onClick={e => onMenuClick(subMenu, e)}
            >
              <Icon
                class={`${subMenu.icon} sub-menu--icon flex-shrink-0`}
                size={24}
              />
              <div
                className="sub-menu--title"
                onClick={e => onMenuClick(subMenu, e)}
              >
                <span dangerouslySetInnerHTML={{ __html: subMenu.title }} />
                {subMenu.isNew && (
                  <div className="sub-menu--new icon-new-green-bg">NEW</div>
                )}
              </div>
              {subMenu.key !== 'logout' && (
                <Icon
                  class="icon-common-red-arrow-right flex-shrink-0"
                  size={15}
                />
              )}
            </a>
          );
        } else if (
          !isUserLoggedIn &&
          (subMenu.key === 'logout' || subMenu.key === 'orders')
        ) {
          return false;
        } else {
          return (
            <Link
              to={getMenuLinks(subMenu)}
              className={`sub-menu justify-content--space-between ${
                subMenu.isPrivate && !isUserLoggedIn ? 'inactive' : ''
              }`}
              key={subMenu.key}
              onClick={e => onMenuClick(subMenu, e)}
            >
              <Icon
                class={`${subMenu.icon} sub-menu--icon flex-shrink-0`}
                size={24}
              />
              <div
                className={`${
                  subMenu.key === props.activeMenu ||
                  ('faq-list' === props.activeMenu && 'faqs' === subMenu.key) ||
                  ('order-details' === props.activeMenu &&
                    'orders' === subMenu.key)
                    ? 'sub-menu--title-active'
                    : 'sub-menu--title'
                }`}
                onClick={e => onMenuClick(subMenu, e)}
              >
                <span dangerouslySetInnerHTML={{ __html: subMenu.title }} />
                {subMenu.isNew && (
                  <div className="sub-menu--new icon-new-green-bg">NEW</div>
                )}
              </div>
              {subMenu.key !== 'logout' && (
                <Icon
                  class="icon-common-red-arrow-right flex-shrink-0"
                  size={15}
                />
              )}
            </Link>
          );
        }
      })}
      {index == 0 && (
        <div className="ac-menu--refer-container">
          <InviteAndEarn
            iGet={props.launchInfo?.referrerRewardAmount}
            myFriendsGet={props.launchInfo?.refereeRewardAmount}
            source="account"
            redirectTo={
              props.launchInfo?.loggedIn
                ? '/my/vxl-point'
                : '/login?redirectUrl=my/vxl-point'
            }
          />
        </div>
      )}
    </div>
  ));
};
const mapStateToProps = ({ initialReducer }) => ({
  launchInfo: initialReducer.launchInfo,
});
const mapDispatchToProps = {
  showLoginModal,
};
export default connect(mapStateToProps, mapDispatchToProps)(AccountMenu);
